import { createContext } from 'react';

import { Language } from 'generated/webapp_gql';

export const SurveyLanguageContext = createContext<Language | undefined>(undefined);
